/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { Link } from "react-router-dom";
import Axios from 'axios';
import { diffInDays } from './utility';
import { Badge, Table, Button, Card, Row, Col } from 'react-bootstrap';

const CoachingListAdmin = () => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);

    const [itemEvents, setItemEvents] = useState([]);
    const [renewals, setRenewals] = useState([]);

    const fetchClient = () => {
        coreContext.fetchSelf(authContext.itemId);
        coreContext.fetchSahyogEvents(authContext.ownerId, 'active');
        fetchEvents();
        fetchRenewals();
    }

    useEffect(fetchClient, []);

    const fetchEvents = () => {
        Axios.get('/jnv-sahyog-events-my-contributions', { params: { itemId: authContext.itemId } }).then(response => {
            const eids = [];
            const events = [];
            const evs = response.data.events;
            evs.forEach(event => {
                if (!eids.includes(event.id)) {
                    eids.push(event.id);
                    events.push(event);
                }
            });
            setItemEvents(events);
        }).catch(err => {
            console.error(err);
        });
    }

    const fetchRenewals = () => {
        Axios.get('/my-renewals', { params: { itemId: authContext.itemId } }).then(response => {
            const evs = response.data.events;
            setRenewals(evs);
        }).catch(err => {
            console.error(err);
        });
    }

    const renderEvents = () => {
        if (itemEvents.length > 0) {
            return itemEvents.map((se, index) => {
                return (
                    <tr key={++index}>
                        <th>{index}</th>
                        <td><strong>{se.comments}</strong></td>
                        <td>{new Date(se.createdAt).toDateString()}</td>
                        <td className="text-success font-weight-bold">₹{se.amount}</td>
                        <td><code className="text-dark">{se.paymentUrl || '-'}</code></td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="5" className="text-center text-muted py-3">No contributions recorded yet.</td>
                </tr>
            );
        }
    }

    const renderRenewals = () => {
        if (renewals.length > 0) {
            return renewals.map((se, index) => {
                return (
                    <tr key={++index}>
                        <th>{index}</th>
                        <td><strong>{se.comments}</strong></td>
                        <td>{new Date(se.createdAt).toDateString()}</td>
                        <td className="text-success font-weight-bold">₹{se.amount}</td>
                        <td><code className="text-dark">{se.paymentUrl || '-'}</code></td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="5" className="text-center text-muted py-3">No renewal records yet.</td>
                </tr>
            );
        }
    }

    const bookingStatus = () => {
        if (coreContext.client.smst_payment_done === 'no') {
            return (
                <div className="p-3 bg-light rounded border border-warning">
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                        <div>
                            <Badge bg="warning" className="text-dark mb-1">Registration Pending</Badge>
                            <p className="mb-0 text-muted small">Please deposit your Vyavastha Shulk to complete membership.</p>
                        </div>
                        <Link className="btn btn-warning btn-sm" to="/pay-membership-fees">
                            Complete Registration
                        </Link>
                    </div>
                </div>
            );
        } else {
            const diff = 365 - (diffInDays(new Date(coreContext.client.membership_start_date), new Date()));
            const isExpired = diff < 0;
            const isExpiringSoon = diff >= 0 && diff < 30;

            if (isExpired) {
                return (
                    <div className="p-3 bg-light rounded border border-danger">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <div>
                                <Badge bg="danger" className="mb-1">Subscription Expired</Badge>
                                <p className="mb-0 text-danger small">Your subscription has expired. Please renew your Vyavastha Shulk.</p>
                            </div>
                            <Link className="btn btn-danger btn-sm" to="/pay-membership-fees">
                                Renew Membership
                            </Link>
                        </div>
                    </div>
                );
            }

            if (isExpiringSoon) {
                return (
                    <div className="p-3 bg-light rounded border border-warning">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <div>
                                <Badge bg="warning" className="text-dark mb-1">Expires in {diff} days</Badge>
                                <p className="mb-0 text-muted small">Your subscription is expiring soon. Renew to stay active.</p>
                            </div>
                            <Link className="btn btn-warning btn-sm" to="/pay-membership-fees">
                                Pay Vyavastha Shulk
                            </Link>
                        </div>
                    </div>
                );
            }

            return (
                <div className="p-3 bg-light rounded border border-success">
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                        <div>
                            <Badge bg="success" className="mb-1">Active Member</Badge>
                            <p className="mb-0 text-success small font-weight-bold">✓ Successfully registered. Subscription is active ({diff} days remaining).</p>
                        </div>
                        <a className="btn btn-outline-success btn-sm" href="https://swabhimanjnv.in" target="_blank" rel="noopener noreferrer">
                            Visit Website
                        </a>
                    </div>
                </div>
            );
        }
    }

    const abstractStatus = () => {
        return (
            <div className="p-3 bg-light rounded border d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div>
                    <strong>{coreContext.client.item_name || 'Member Profile'}</strong>
                    <div className="text-muted small">{coreContext.client.item_email || ''}</div>
                </div>
                <Link className="btn btn-primary btn-sm" to="/profile">
                    View Full Profile
                </Link>
            </div>
        );
    }

    const getTotalAmount = () => {
        let tam = 0;
        itemEvents.forEach(ie => {
            tam += parseInt(ie.amount, 10) || 0;
        });
        return tam;
    }

    const renderCertificate = (certificate) => {
        if (certificate) {
            if (certificate.includes('.pdf')) {
                return <a rel="noopener noreferrer" target="_blank" href={`https://${certificate}`}><img style={{ height: '40px', borderRadius: '4px' }} className="img-thumbnail" src="https://node-websites.siddhantait.com/images/pdfimage.png" alt='Certificate' /></a>;
            } else {
                return <img style={{ height: '40px', borderRadius: '4px', objectFit: 'cover' }} className="img-thumbnail" src={`https://${certificate}`} alt='Certificate' />;
            }
        }
        return <span className="text-muted small">No file</span>;
    }

    const renderActiveEvents = () => {
        if (coreContext.sahyogEvents.length > 0) {
            return coreContext.sahyogEvents.map((se, index) => {
                return (
                    <tr key={++index}>
                        <th>{index}</th>
                        <td><strong>{se.item_name}</strong></td>
                        <td>{se.district}</td>
                        <td>{se.address}</td>
                        <td>{se.membership_start_date}</td>
                        <td>{se.comments}</td>
                        <td>{renderCertificate(se.imageUrl)}</td>
                        <td>
                            <Link className="btn btn-outline-danger btn-sm" to={{ pathname: `/contribute-in-sahyog/${se.id}`, state: { event: se } }}>
                                Contribute
                            </Link>
                        </td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="8" className="text-center text-muted py-3">No active events currently.</td>
                </tr>
            );
        }
    }

    return (
        <div className="dashboard-container pb-4">
            {/* Top Row: Registration Status, My Profile, Financial Docs */}
            <Row className="g-3 mb-3">
                <Col lg={6}>
                    <Card className="h-100 shadow-sm">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <span>📋 Registration Status</span>
                        </Card.Header>
                        <Card.Body>
                            {bookingStatus()}
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={3} sm={6}>
                    <Card className="h-100 shadow-sm">
                        <Card.Header>👤 My Profile</Card.Header>
                        <Card.Body>
                            {abstractStatus()}
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={3} sm={6}>
                    <Card className="h-100 shadow-sm">
                        <Card.Header>📄 Documents</Card.Header>
                        <Card.Body className="d-flex flex-column justify-content-between">
                            <p className="text-muted small mb-2">Access official Swabhiman financial reports & receipts.</p>
                            <a target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary btn-sm" href="https://swabhimanjnv.com/financial-documents">
                                View Documents ↗
                            </a>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Middle Row: My Contributions & My Renewals */}
            <Row className="g-3 mb-3">
                <Col lg={6}>
                    <Card className="shadow-sm">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <span>🤝 My Contributions</span>
                            {itemEvents.length > 0 && (
                                <Badge bg="success" className="px-2 py-1">
                                    Total: ₹{getTotalAmount()}
                                </Badge>
                            )}
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Table responsive hover className="mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Event / Details</th>
                                        <th>Payment Date</th>
                                        <th>Amount</th>
                                        <th>Payment ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderEvents()}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={6}>
                    <Card className="shadow-sm">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <span>🔄 My Renewals</span>
                            <Link className="btn btn-primary btn-sm" to='/pay-membership-fees'>
                                Pay Vyavastha Shulk
                            </Link>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Table responsive hover className="mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Event / Purpose</th>
                                        <th>Payment Date</th>
                                        <th>Amount</th>
                                        <th>Payment ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderRenewals()}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Bottom Row: Sahyog Events */}
            <Row className="g-3">
                <Col xs={12}>
                    <Card className="shadow-sm">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <span>❤️ Sahyog Events (Active)</span>
                            <Link className="btn btn-outline-primary btn-sm" to='sahyog-events'>
                                View All Events ↗
                            </Link>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Table responsive hover className="mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>District</th>
                                        <th>Address</th>
                                        <th>Joining</th>
                                        <th>Details</th>
                                        <th>Attachment</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderActiveEvents()}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export { CoachingListAdmin };